import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { InstitucionComponent } from "./institucion/institucion.component";


const routes: Routes = [
      {
        path: '',
        children: [
          {
            path: 'institucion',
            component: InstitucionComponent,
            data: {
              title: "Institución",
              breadcrumb: "Institución"
            }
          }
        ]
      }
]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class InstitucionRoutingModule {}